<script>
	import UnathContext from '../../layouts/UnathContext.svelte';
	import { navigate } from 'svelte-routing';
	import queryString from 'query-string';
	import firebase from '../../firebase';

	const code = queryString.parse(window.location.search).code;
    const promise = firebase.auth().applyActionCode(code);
</script>

<UnathContext title="Verify email">
	<div class="modal">
		<div class="modal__box modal__box--sm">
			<div class="modal__header">
				Verify email
			</div>
			<div class="modal__body layout">
				<div class="layout__column">
					{#await promise}
						<div class="layout__item">Verifying...</div>
					{:then result}
						<div class="layout__item success-message">Email successfully verified.</div>
					{:catch error}
						<div class="layout__item error-message">{error.message}</div>
					{/await}
					<div class="layout__row layout__row--space-between">
						<div class="layout__item">
							<div
								class="form__button form__button--subtle"
								on:click={() => navigate('/auth/sign-in')}>
								Go to sign in
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</UnathContext>